import { useState } from 'react';
import InitFilters from './SubsetList/constants/InitFiltering';

const useCustomHook = () => {
  const [isSubmiting, setIsSubmiting] = useState(false);
  const [selectedTags, setSelectedTags] = useState([]);
  const [BranchDetails, setBranchDetails] = useState([]);

  const [selectedCheckData, setSelectedCheckData] = useState(null);

  const [loading, setLoading] = useState(false);
  const [filterParams, setFilterParams] = useState(null);
  const [size, setSize] = useState(12);
  const [filters, setFilters] = useState(InitFilters());
  const [page, setPage] = useState(0);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [loadingStates, setLoadingStates] = useState(false);
  const [loadingCities, setLoadingCities] = useState(false);
  const [loadingUserInfo, setLoadingUserInfo] = useState(true);
  const [userSSOid, setUserSSOid] = useState(0);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [city, setCity] = useState();
  const [cityId, setCityId] = useState();
  const [provinceId, setProvinceId] = useState();
  const [province, setProvince] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotoalCount] = useState(0);

  const [guildSearchText, setGuildSearchText] = useState('');
  const [selectedGuilds, setSelectedGuilds] = useState([]);
  const [loadingBtnAccept, setLoadingBtnAccept] = useState(false);
  const [loadingBtnIgnore, setLoadingBtnIgnore] = useState(false);
  const [formData, setFormData] = useState(null);

  const [title, setTitle] = useState('');
  const [isImprest, setIsImprest] = useState(false);
  const [firstLoad, setFirstLoad] = useState(1);
  const [defaultProvince, setDefaultProvince] = useState(null);
  const [defaultCity, setDefaultCity] = useState(null);

  const [loadingBtn, setLoadingBtn] = useState(false);
  const [dialog, setDialog] = useState({});

  const [branchData, setBranchData] = useState(null);
  const [cameFromGuilds, setCameFromGuilds] = useState(false);
  const [dateServer, setDateServer] = useState({ start: null, end: null });
  const [isLoadingPage, setIsLoadingPage] = useState(true);

  const [isOpenTagDialog, setIsOpenTagDialog] = useState(false);
  const [isOpenUploadDialog, setIsOpenUploadDialog] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [billTags, setBillTags] = useState([]);
  const [accountNumberOptions, setAccountNumberOptions] = useState([]);
  const [loadingPage, setLoadingPage] = useState(false);
  const [isLoadingExport, setIsLoadingEport] = useState(false);
  const [isShowExport, setIsShowEport] = useState(false);
  const [isOpenExportDG, setIsOpenExportDG] = useState(false);
  const [isOpenShowExportDG, setIsOpenShowExportDG] = useState(false);

  const [statistics, setStatistics] = useState({
    totalInventory: 0,
    totalDeposit: 0,
    creditAmount: 0,
    lastCredit: 0,
    totalCredit: 0,
  });
  const [beforeUlpoadList, setBeforeUlpoadList] = useState([]);




  const [changeOwner, setChangeOwner] = useState(false);
  return {
    BranchDetails, setBranchDetails,
    selectedCheckData, setSelectedCheckData,
    changeOwner, setChangeOwner,
    isSubmiting, setIsSubmiting,
    beforeUlpoadList, setBeforeUlpoadList,
    selectedTags, setSelectedTags,
    loadingBtnAccept, setLoadingBtnAccept,
    loadingBtnIgnore, setLoadingBtnIgnore,
    isOpenTagDialog,
    setIsOpenTagDialog,
    isOpenUploadDialog,
    setIsOpenUploadDialog,
    selectedRow,
    setSelectedRow,
    billTags,
    setBillTags,
    accountNumberOptions,
    setAccountNumberOptions,
    loadingPage,
    setLoadingPage,
    isLoadingExport,
    setIsLoadingEport,
    isShowExport,
    setIsShowEport,
    filterParams,
    setFilterParams,
    isOpenExportDG,
    setIsOpenExportDG,
    isOpenShowExportDG,
    setIsOpenShowExportDG,
    statistics,
    setStatistics,
    filterParams,
    branchData,
    setBranchData,
    cameFromGuilds,
    setCameFromGuilds,
    dateServer,
    setDateServer,
    isLoadingPage,
    setIsLoadingPage,

    loadingBtn,
    setLoadingBtn,
    dialog,
    setDialog,

    isImprest,
    setIsImprest,
    title,
    setTitle,
    firstLoad,
    setFirstLoad,
    defaultProvince,
    setDefaultProvince,
    defaultCity,
    setDefaultCity,
    formData,
    setFormData,
    submitLoading,
    setSubmitLoading,
    loadingStates,
    setLoadingStates,
    loadingCities,
    setLoadingCities,
    loadingUserInfo,
    setLoadingUserInfo,
    userSSOid,
    setUserSSOid,
    states,
    setStates,
    cities,
    setCities,
    city,
    setCity,
    cityId,
    setCityId,
    provinceId,
    setProvinceId,
    province,
    setProvince,
    guildSearchText,
    setGuildSearchText,
    selectedGuilds,
    setSelectedGuilds,
    currentPage, setCurrentPage,
    filters,
    setFilters,
    page, setPage,
    setFilterParams,
    loading,
    setLoading,
    totalCount, setTotoalCount,
    size,
    setSize,
  };
};

export default useCustomHook;
